import React, { useEffect } from "react";
import ProjectDescription from '../components/ProjectDescription';
import { Helmet } from "react-helmet";
import { Container, Row, Col } from 'react-grid-system';
import  ProjectModel from '../models/ProjectModel';
import ProjectIndex from '../components/ProjectIndex';
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import '../App.css';

function TheVergeOfflineActivities({dispatch}) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  return (

<div className="wrapper">

	<Helmet>
		<meta charSet="utf-8" />
		<title>Maria Chimishkyan — {ProjectModel.TheVergeOfflineActivities.title}</title>
	</Helmet>

	<div className="inner-wrapper">
	    <Container fluid className="page-pad">
	    	<Row>
	    		<Col sm={3}>
	    			<div className="description-sticky">
	    			  <ProjectDescription projectModel={ProjectModel.TheVergeOfflineActivities}/>
	    			</div>
	    		</Col>
	    		<Col sm={6}>
	    			<img src="img/project-page/the-verge-offline-activities/theverge-offlineactivities-MariaChimishkyan-1.jpg" alt="The Verge — Offline Activities — Maria Chimishkyan 1" style={{ width: '100%' }}/>
	    			<div style={{ marginTop: '100px' }}>
	    				<img src="img/project-page/the-verge-offline-activities/theverge-offlineactivities-MariaChimishkyan-2.jpg" alt="The Verge — Offline Activities — Maria Chimishkyan 2" style={{ width: '100%' }}/>
	    			</div>
	    		</Col>
	    	</Row>
	    </Container>
	</div>
	<ProjectIndex/>
</div>

  )
}

export default connect()(TheVergeOfflineActivities);
